import { X, Save, Eye, List, FileText, Presentation } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import type { useProposalStudio } from './useProposalStudio'
import { openStudioPresentation } from './openStudioPresentation'

type Studio = ReturnType<typeof useProposalStudio>

export function ProposalStudioHeader({ s }: { s: Studio }) {
  return (
    <div className="flex items-center justify-between px-5 py-3 border-b border-white/[0.06] shrink-0">
      <div className="flex items-center gap-3">
        <h2 className="text-lg font-bold text-text-primary">Proposal Studio</h2>
        <span className="text-xs text-text-muted bg-white/[0.06] px-2 py-0.5 rounded">
          {s.deal.empresaNome}
        </span>
        <div className="flex items-center gap-1 ml-4 bg-white/[0.04] p-0.5 rounded-lg border border-white/[0.06]">
          <button
            type="button"
            onClick={() => s.setViewMode('items')}
            className={`flex items-center gap-1 px-2.5 py-1 rounded-md text-[11px] font-medium transition-all ${
              s.viewMode === 'items' ? 'bg-accent text-white' : 'text-text-muted hover:text-text-primary'
            }`}
          >
            <List size={12} />
            Itens
          </button>
          <button
            type="button"
            onClick={() => s.setViewMode('preview')}
            className={`flex items-center gap-1 px-2.5 py-1 rounded-md text-[11px] font-medium transition-all ${
              s.viewMode === 'preview' ? 'bg-accent text-white' : 'text-text-muted hover:text-text-primary'
            }`}
          >
            <Eye size={12} />
            Visual
          </button>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="secondary"
          size="sm"
          icon={<Presentation size={13} />}
          onClick={() => openStudioPresentation(s)}
        >
          Apresentar
        </Button>
        <Button
          variant="secondary"
          size="sm"
          icon={<FileText size={13} />}
          loading={s.savingAsTemplate}
          onClick={() => {
            const mode = s.viewMode
            const index = s.activeIndex
            void s.handleExportPdf({
              slideCount: Math.max(s.slideOptions.length, 1),
              showSlide: async (slideIndex) => {
                s.setViewMode('preview')
                s.setActiveIndex(slideIndex)
                await new Promise((resolve) => setTimeout(resolve, 140))
              },
              restore: () => {
                s.setViewMode(mode)
                s.setActiveIndex(index)
              },
            })
          }}
        >
          Exportar PDF
        </Button>
        <Button
          variant="primary"
          size="sm"
          icon={<Save size={13} />}
          loading={s.saving}
          onClick={s.handleSave}
        >
          Salvar Proposta
        </Button>
        <button
          type="button"
          onClick={s.onClose}
          className="p-2 rounded-md text-text-muted hover:text-text-primary hover:bg-white/[0.06] transition-colors"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  )
}
